import React from 'react'
import { Link } from 'react-router-dom'
import TopArtistsItem from './TopArtistsItem'

function TopArtists( { title, subtitle, viewPage }) {
    return (
        <div className="singleMarketMove">
            <div className="itemHeading">
                <h3 className="left"> { title } </h3>
                <p><small className="right"> { subtitle } </small></p>
            </div>
                <TopArtistsItem
                    userPath = "/user/username"
                    userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                    userName = "@username"
                    amount = { 938282 }
                />
                <TopArtistsItem
                    userPath = "/user/username"
                    userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                    userName = "@username"
                    amount = { 238822 }
                />
                <TopArtistsItem
                    userPath = "/user/username"
                    userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                    userName = "@username"
                    amount = { 134282 }
                />
                <Link to={viewPage} className="itemFootOpt">See All</Link>
        </div>
    )
}

export default TopArtists
